import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import { type ReactNode, forwardRef } from 'react'
import Sidebar from '../Sidebar'

export interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode
}

export default forwardRef<HTMLDivElement, LayoutProps>(function Layout(
	{ children, ...props }: LayoutProps,
	ref
) {
	return (
		<div
			ref={ref}
			css={css`
				display: flex;
				min-height: 100vh;
			`}
			{...props}
		>
			<Sidebar />
			<div
				css={css`
					flex: 1;
				`}
			>
				{children}
			</div>
		</div>
	)
})
